import { TabletCellphoneIcon } from './TabletCellphoneIcon';

/**
 * author: Google
 * id 804E3CCD-99B5-4F54-898A-9477D69E6951
 * name tablet-cellphone
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tablet-cellphone.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const MobileDevicesIcon = TabletCellphoneIcon;
export default MobileDevicesIcon